import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserStatusesModel } from './user-statuses.datamodel';
import { CookieService } from 'web-common/src/app/cookie.service';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class UserStatusesService {

  constructor(private http: HttpClient, private cookieService: CookieService) { }

  private setHeaders(): HttpHeaders {
    let cookieString = 'id=' + this.cookieService.get('id') + '; user_token=' + this.cookieService.get('user_token') + ';';
    let headers = new HttpHeaders()
      .append('cookiestring', cookieString)
      .append('Content-Type', 'application/json')
      .append('apiversion', '1')
      .append('appid', environment.appId);

    return headers;
  }
  public fetchUsers = (pageNumber: number = 0, email: string = '', length: number = 50, showDisabled: boolean = false, lastActive: string = 'ALL',
                       showDisabledAccounts: boolean = true, showEnabledAccounts: boolean = true, onlyAdmins: boolean = false,
                       selectedRoles: string[] = [], selectedArea: string[] = [], selectedAdditional: string[] = [],
                       sortField: string = '', sortType: string = ''):
    Observable<UserStatusesModel> => {

    const requestBody = {
      'pageNumber': pageNumber,
      'pageRecords': length,
      'search': decodeURIComponent(email.trim()),
      'lastActive': lastActive,
      'roles': selectedRoles,
      'areaOfFocus': selectedArea,
      'additionalProfileInformation': selectedAdditional,
      'showDisabledAccounts': showDisabledAccounts,
      'showEnabledAccounts': showEnabledAccounts,
      'onlyAdmins': onlyAdmins,
      'sortField': sortField,
      'sortType': sortType
    };

    return this.http.post<UserStatusesModel>(environment.rw3apiURL + 'user/institutionUsers/',
      requestBody,
      {headers: this.setHeaders()})
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      )
  }

  public fetchInvited = (pageNumber: number = 0, email: string = '', length: number = 50):
    Observable<UserStatusesModel> => {

    const requestBody = {
      'pageNumber': pageNumber,
      'pageRecords': length,
      'search': decodeURIComponent(email.trim()),
      'sortField': 'email',
      'sortType': 'ASC'
    };

    return this.http.post<UserStatusesModel>(environment.rw3apiURL + 'user/admin/invites/',
      requestBody,
      {headers: this.setHeaders()})
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      )
  }

  public getSummaryTableData = ():
    Observable<UserStatusesModel> => {

    return this.http.get<UserStatusesModel>(environment.rw3apiURL + 'user/admin/summary/',
      { headers: this.setHeaders() })
      .pipe(
        map((response) => {
          return response;
        }, error => {
          return error;
        })
      )
  }

  public getSeatLimitData = (discountGroupId: string):
    Observable<any> => {

    return this.http.get<any>(environment.rw3apiURL + 'institution/' + discountGroupId + '/limit',
      { headers: this.setHeaders() })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      )
  }

  public handleError (error: any) {
    // TODO: Use a remote logging infrastructure
    let errMsg: string;
    //! not sure if this works
    if (error.status) {
      const body = error || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return observableThrowError(errMsg);
  }


}
